import classnames from "classnames";
import React, { ReactNode } from "react";
import { URLParts, urlForDocument } from "../../urls";
import Link from "../Link/Link";
import {
  toolbarNavBoldLinkClass,
  toolbarNavUnderlineLinkClass
} from "../Toolbar/ToolBarNav/ToolBarNav";

const NavLink = ({
  activeClassName,
  children,
  className,
  data,
  href,
  partiallyActive,
  onClick,
  role
}: {
  activeClassName?: string;
  children: ReactNode;
  className?: string;
  data?: URLParts;
  href?: string;
  partiallyActive?: boolean;
  onClick?: (event: React.MouseEvent<HTMLAnchorElement, MouseEvent>) => void;
  role?: string;
}) => (
  <Link
    onClick={onClick}
    className={className}
    to={data ? urlForDocument(data!) : href!}
    activeClassName={
      activeClassName ||
      classnames(toolbarNavBoldLinkClass, toolbarNavUnderlineLinkClass)
    }
    partiallyActive={partiallyActive}
    role={role}
  >
    {children}
  </Link>
);

export default NavLink;
